/* eslint-disable max-lines-per-function */
import { updateOrders, updateEmptyState } from "components/supplier_admin/shared/queue_polling";

const updateState = ({
  payload,
  $container,
  $noticeEl,
  $futureCountEl,
  $summaryTotalEl,
  $summaryPrintEl,
  $summaryTransferEl,
  state
}) => {
  state.lastUpdated = payload.last_updated;
  $container.dataset.printerQueueLastUpdated = state.lastUpdated;

  if (!payload.job_counts) return;

  if (payload.job_counts.future_active_count !== undefined) {
    if ($futureCountEl) {
      $futureCountEl.textContent = payload.job_counts.future_active_count;
    }
    if ($noticeEl) {
      const hasFutureJobs = Number(payload.job_counts.future_active_count) > 0;
      $noticeEl.classList.toggle("printer-queue__notice--hidden", !hasFutureJobs);
    }
  }

  if (payload.job_counts.current) {
    const counts = payload.job_counts.current;
    const isFinished = state.status === "finished";
    const totalCount = isFinished ? counts.total_finished_count : counts.total_active_count;
    const printCount = isFinished
      ? counts.total_finished_print_count
      : counts.total_active_print_count;
    const transferCount = isFinished
      ? counts.total_finished_transfers_count
      : counts.total_active_transfers_count;

    if ($summaryTotalEl) $summaryTotalEl.textContent = totalCount;
    if ($summaryPrintEl) $summaryPrintEl.textContent = printCount;
    if ($summaryTransferEl) $summaryTransferEl.textContent = transferCount;
  }
};

const applyPayload = ({
  payload,
  state,
  $container,
  $listEl,
  $noticeEl,
  $futureCountEl,
  $summaryTotalEl,
  $summaryPrintEl,
  $summaryTransferEl,
  $emptyStateEl,
  $paginationEl
}) => {
  updateState({
    payload,
    $container,
    $noticeEl,
    $futureCountEl,
    $summaryTotalEl,
    $summaryPrintEl,
    $summaryTransferEl,
    state
  });
  updateOrders($listEl, payload.jobs_html);
  updateEmptyState({
    ordersCount: payload.filtered_jobs_count,
    $emptyStateEl,
    $listEl,
    $paginationEl
  });
};

export default applyPayload;
